export default __webpack_public_path__ + "static/media/lte_m_rgb.f7fa6036.png";